import "babel-polyfill";
import "./libs/slick";
import "./libs/jcf/jcf.js";
import "./libs/jcf/jcf.scrollable.js";
import "./libs/jcf/jcf.select.js";

import {binder, fwa} from "./libs/binder";
import {staticFunctions, constants} from "./modules/module";
import {collectionSlider} from "./modules/collection-slider";
import {testimonialsSlider} from "./modules/testimonials-slider";
import {accessArtSlider} from "./modules/access-art-slider";
import {collectionsSlider} from "./modules/collections-slider";
import {heroSlider} from "./modules/hero-slider";
import {heroAudio} from "./modules/hero-audio";
import {seeAlsoSlider} from "./modules/see-also-slider";
import {artworkVideoSlider} from "./modules/artwork-video-slider";
import {scrollButton} from "./modules/scroll-button";
import {slowSlider} from "./modules/slow-slider";
import {inlineVideo} from "./modules/inline-video";
import {mainNav} from "./modules/mainNav";
import {pictureSlider} from "./modules/picture-slider";
import {artworkAudio} from "./modules/artworkAudio";
import {print} from "./modules/print";
import {overviewAnimation} from "./modules/overviewAnimation";
import {artworkMediaSticky} from "./modules/artworkMediaSticky";
import {aboutInfoAnimate} from "./modules/aboutInfoAnimate";
import {stickify} from "./modules/stickify";
import {insertSvgPagination} from "./modules/insertSvgPagination";
import {customSelect} from "./modules/customSelect";
import {parallax} from "./modules/parallax";
import {artworkHeroAnimation} from "./modules/artworkHeroAnimation";
import {searchClear} from "./modules/searchClear";
import {hoverNewsWorks} from "./modules/hoverNewsWorks";
import {overviewSmallSliderAnimation} from "./modules/overviewSmallSliderAnimation";
import {iframeContentWidth} from "./modules/iframeContentWidth";


binder({
    bounds: {
        "html": constants,
        ".artwork-hero .media-info": artworkMediaSticky,
        ".header": mainNav,
        ".collection-slider": collectionSlider,
        ".access-art": accessArtSlider,
        ".testimonials": testimonialsSlider,
        ".collections": collectionsSlider,
        ".hero-section": heroSlider,
        "#hero-audio": heroAudio,
        ".slow-slider": slowSlider,
        ".inline-video": inlineVideo,
        ".see-also": seeAlsoSlider,
        ".artwork-videos": artworkVideoSlider,
        ".button-scroll": scrollButton,
        ".picture-slider": pictureSlider,
        ".media-info .audio": artworkAudio,
        "[aria-label*=\"pdf\"]": print,
        ".overview .slow-slider": overviewAnimation,
        ".about-us-info": aboutInfoAnimate,
        ".collection-detail-heading,.newsroom-contact": stickify,
        ".pagination": insertSvgPagination,
        "select": customSelect,
        ".has-parallax": parallax,
        ".artwork-hero": artworkHeroAnimation,
        ".search-form": searchClear,
        ".news-listing,.collection-detail": hoverNewsWorks,
        ".explore .slow-slider": overviewSmallSliderAnimation,
        ".content iframe": iframeContentWidth
    },
    runTests: false
});



// WEBPACK FOOTER //
// ./assets/js/global.js